export enum CameraVariantLineEnum {
    SELFIE = 'selfie',
    DOCS = 'docs',
    POA = 'poa',
}
